<div class="container-fluid basic_table">
  <div class="row">
    <div class="card">
      <div class="card-header">
        <div
          class="d-flex flex-nowrap justify-content-end align-items-center gap-2"
        >
          @if (isSupportMode) {
          <div
            class="input-group cw-support-search me-auto"
            [class.cw-support-search--active]="appliedSupportRequestId"
          >
            <label class="input-group-text" for="cwSupportRequestId">ID Solicitud</label>
            <input
              id="cwSupportRequestId"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              class="form-control"
              placeholder="Ej: 60"
              aria-label="Buscar solicitud por ID"
              [(ngModel)]="supportRequestId"
              [disabled]="isLoading"
              (keyup.enter)="searchByRequestId()"
            />
            @if (appliedSupportRequestId) {
            <button
              type="button"
              class="btn btn-outline-secondary"
              aria-label="Quitar búsqueda por ID"
              ngbTooltip="Quitar búsqueda por ID"
              tooltipClass="custom-tooltip"
              [disabled]="isLoading"
              (click)="clearSupportRequestId()"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
            }
            <button
              type="button"
              class="btn primary-button"
              aria-label="Buscar por ID"
              ngbTooltip="Buscar por ID (ignora las fechas del filtro)"
              tooltipClass="custom-tooltip"
              [disabled]="isLoading"
              (click)="searchByRequestId()"
            >
              <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            </button>
          </div>
          }

          @if (hasPermission(REQUEST_WITHDRAWAL_PERMISSIONS.PROCESSED_QUEUE)) {
          <button
            [ngClass]="isProcessedQueueFiltered ? 'btn-processed-queue-active' : 'primary-button'"
            [disabled]="isLoading || procesadoQueueCount === 0"
            (click)="filterByProcessed()"
            [ngbTooltip]="isProcessedQueueFiltered ? 'Filtro activo: Procesadas en cola' : 'Filtrar solicitudes procesadas en cola'"
            tooltipClass="custom-tooltip"
          >
            @if (isProcessedQueueFiltered) {
              <i class="fa-solid fa-filter"></i>
            }
            Solicitudes Procesadas en cola ({{ procesadoQueueCount }})
          </button>
          @if (isProcessedQueueFiltered) {
          <button
            class="primary-button-cancel-sm"
            [disabled]="isLoading"
            (click)="resetProcessedFilter()"
            ngbTooltip="Quitar filtro"
            tooltipClass="custom-tooltip"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          }
          }
          @if (rol !== ROLES.AGENT) {
          <button
            class="refresh-button"
            [disabled]="isLoading"
            (click)="toggleSocket()"
            [ngbTooltip]="
              isSocketPaused ? 'Reanudar Solicitudes' : 'Pausar Solicitudes'
            "
            tooltipClass="custom-tooltip"
          >
            <i
              [ngClass]="
                isSocketPaused ? 'fa-solid fa-play' : 'fa-solid fa-pause'
              "
            ></i>
          </button>
          }
          <button
            class="refresh-button"
            [disabled]="isLoading"
            ngbTooltip="Recargar Tabla"
            tooltipClass="custom-tooltip"
            (click)="reloadTable()"
          >
            <i class="fas fa-sync-alt"></i>
          </button>
          @if (
            hasPermission(
              REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_REPEATED_VOUCHERS
            )
          ) {
            <button
              class="btn btn-sm"
              [ngClass]="
                isRepeatedVouchersViewerMinimized
                  ? 'btn-repeated-vouchers-close'
                  : 'btn-warning'
              "
              [disabled]="isLoading"
              [ngbTooltip]="
                isRepeatedVouchersViewerMinimized
                  ? 'Cerrar Visor de Comprobantes Repetidos'
                  : 'Comprobantes repetidos'
              "
              tooltipClass="custom-tooltip"
              (click)="toggleRepeatedVouchersViewer()"
            >
              <i
                [ngClass]="
                  isRepeatedVouchersViewerMinimized
                    ? 'fas fa-times'
                    : 'fas fa-clone'
                "
              ></i>
            </button>
          }

          @if (!isMobile) { @if (buttonDownloadExcelAllowed) {
          <button
            class="primary-button-sm"
            ngbTooltip="Descargar Información en .xls"
            tooltipClass="custom-tooltip"
            [disabled]="isLoading"
            (click)="exportToExcel()"
          >
            <i class="far fa-file-excel"></i>
          </button>
          } } @if (buttonAllowed) {
          <button
            class="primary-button"
            [disabled]="isLoading"
            (click)="openCreateCwFormModal()"
          >
            <i class="fa-solid fa-circle-plus"></i> Nueva Solicitud
          </button>
          }
        </div>
      </div>
      @if (!(isMobile$ | async)) {
      <div class="card-body custom-datatable noscroll">
        <div class="table-responsive signal-table custom-datatable">
          <table class="table table-hover table-responsive">
            <thead class="mx-auto text-center">
              <tr>
                @for (column of columnsTable; track $index) {
                <th>{{ column.name }}</th>
                }
              </tr>
            </thead>
            @if (isLoading) {
            <tbody class="text-center">
              <tr>
                <td [attr.colspan]="columnsTable.length">
                  <div class="loader-box">
                    <div class="loader-16"></div>
                  </div>
                </td>
              </tr>
            </tbody>
            } @if (!isLoading) { @for (item of cwData; track item.id) {
            @if (canViewRowByState(item.estado)) {
            <tbody class="text-center" [id]="'row-' + item.id">
              <tr>
                @if (isSupportMode) {
                <td class="mx-auto text-center">
                  <div class="d-flex justify-content-center align-items-center">
                    <app-support-id [value]="item.id"></app-support-id>
                  </div>
                </td>
                }
                <td class="mx-auto text-center">
                  <div class="d-flex justify-content-center align-items-center">
                    @if (getButtons(item).length > 0) {

                    <div
                      class="btn-group"
                      role="group"
                      aria-label="Button group with nested dropdown"
                    >
                      <div
                        ngbDropdown
                        (openChange)="onDropdownToggle($event)"
                        class="btn-group"
                        role="group"
                      >
                        @if ([TRANSACTION_TYPE_VALUES.LOAD_BALANCE,
                        TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE,
                        TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT
                        ].includes(item.tipo_transaccion) &&
                        [STATE_NAMES.PENDING, ].includes(item.estado)) { @if
                        (buttonFastViewAllowed) {
                        <span
                          class="img-dot"
                          ngbTooltip="Ver Transacción"
                          tooltipClass="custom-tooltip"
                          (click)="openViewModal(item.id)"
                          ><i class="fa-solid fa-eye fa-2xs text-success"></i
                        ></span>
                        } }@else if (item.foto_comprobante &&
                        item.foto_comprobante != '' && item.foto_comprobante !=
                        'null' ) {
                        <span
                          class="img-dot"
                          ngbTooltip="Ver Imagen"
                          tooltipClass="custom-tooltip"
                          (click)="openImageModal(item.id)"
                          ><i class="fa-solid fa-image fa-2xs text-success"></i
                        ></span>
                        }
                        <button
                          type="button"
                          class="btn btn-light"
                          id="dropdownBasic1"
                          ngbTooltip="Más"
                          tooltipClass="custom-tooltip"
                          ngbDropdownToggle
                          (click)="onMoreButtonClick(item)"
                        >
                          <i class="fas fa-plus"></i>
                          @if (item.detalle && item.detalle != 'null' &&
                          !item.detalle.includes('Success')) {
                          <span class="notification-dot"></span>
                          }
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                          <ng-template #botBusyTip>
                            Bot ocupado · {{ botLockRemaining(item) }}
                          </ng-template>
                          <div class="row mx-auto pb-2">
                            @for (btn of getButtons(item); track $index) {
                            <div class="col-4">
                              <button
                                class="btn btn-sm btn-mode mt-2"
                                [ngClass]="btn.btnClass"
                                [class.btn-bot-busy]="isBotLocked(item)"
                                [ngbTooltip]="
                                  isBotLocked(item) ? botBusyTip : btn.tooltip
                                "
                                container="body"
                                [tooltipClass]="
                                  isBotLocked(item)
                                    ? 'custom-tooltip bot-busy-tooltip'
                                    : 'custom-tooltip'
                                "
                                (click)="onActionClick(item, btn)"
                              >
                                <i class="fas" [ngClass]="btn.icon"></i>
                              </button>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      @if (item.operators.pagos || item.operators.atc || item.operators.other) {
                        <div class="operator-avatars">
                          @if (item.operators.pagos) {
                            <button
                              class="operator-avatar pagos"
                              [class.is-active]="item.operators.pagos.isActive"
                              [class.bot-failed]="botFailedIds.has(item.id)"
                              [ngbTooltip]="item.operators.pagos.name + ' (Pagos)'"
                              tooltipClass="custom-tooltip"
                              container="body"
                              type="button"
                            >{{ item.operators.pagos.initials }}</button>
                          }
                          @if (item.operators.atc) {
                            <button
                              class="operator-avatar atc"
                              [class.is-active]="item.operators.atc.isActive"
                              [class.bot-failed]="botFailedIds.has(item.id)"
                              [ngbTooltip]="item.operators.atc.name + ' (ATC)'"
                              tooltipClass="custom-tooltip"
                              container="body"
                              type="button"
                            >{{ item.operators.atc.initials }}</button>
                          }
                          @if (item.operators.other) {
                            <button
                              class="operator-avatar other"
                              [class.is-active]="item.operators.other.isActive"
                              [class.bot-failed]="botFailedIds.has(item.id)"
                              [ngbTooltip]="item.operators.other.name + ' (Otros)'"
                              tooltipClass="custom-tooltip"
                              container="body"
                              type="button"
                            >{{ item.operators.other.initials }}</button>
                          }
                        </div>
                      } @else if (item.updated_by_initials) {
                        <div class="operator-avatars">
                          <button
                            class="operator-avatar other"
                            [class.is-active]="true"
                            [class.bot-failed]="botFailedIds.has(item.id)"
                            [ngbTooltip]="item.updated_by | lowercase"
                            tooltipClass="custom-tooltip"
                            container="body"
                            type="button"
                          >{{ item.updated_by_initials }}</button>
                        </div>
                      }
                    </div>
                    }@else { No hay Acciones Disponibles }
                  </div>
                </td>
                <td class="mx-auto text-center">
                  <div
                    class="d-flex justify-content-center align-items-center position-relative"
                  >
                    <div
                      class="d-flex flex-column align-items-center position-relative"
                    >
                      <i
                        *ngIf="item.estado_tiempo_espera"
                        class="fas fa-business-time fa-sm status-icon-time-out"
                        ngbTooltip="La boleta demorará 20 min"
                        tooltipClass="custom-tooltip"
                      >
                      </i>
                      <span
                        *ngIf="item.estado_revisar_boleta === 1"
                        ngbTooltip="Revisar Boleta"
                        tooltipClass="custom-tooltip"
                        class="status-dot status-dot-check-ticket"
                        [ngClass]="{
                          'status-dot-active': item.estado_revisar_boleta === 1
                        }"
                      >
                      </span>
                      <span
                        *ngIf="
                          (item.id_remoto ||
                            item.solicitud_cruzada === CROSS_REQUEST) &&
                          item.origen === ORIGINS.AGENTS
                        "
                        class="ms-1"
                        ngbTooltip="Solicitud Backoffice"
                        tooltipClass="custom-tooltip"
                      >
                        <img
                          src="../../../../../../../assets/images/logo/zgames-logo.png"
                          alt=""
                          width="15"
                          height="15"
                        />
                      </span>
                      <span
                        *ngIf="
                          item.id_remoto && item.origen === ORIGINS.SORTI_EC
                        "
                        class="ms-1"
                        ngbTooltip="Solicitud Jugadores"
                        tooltipClass="custom-tooltip"
                      >
                        <img
                          src="../../../../../../../assets/images/logo/sorti-icon.png"
                          alt=""
                          width="15"
                          height="15"
                        />
                      </span>
                      <span
                        *ngIf="
                          item.creada_por_agente === CREATED_BY_AGENT &&
                          rol !== ROLES.AGENT
                        "
                        class="ms-1 text-success"
                        ngbTooltip="Solicitud Creada por Agente"
                        tooltipClass="custom-tooltip"
                      >
                        <i class="fa-solid fa-user-tie"></i>
                      </span>
                    </div>
                    <span
                      [ngClass]="getStateClasses(item.estado).classes"
                      [innerHTML]="getStateClasses(item.estado).text"
                      class="status-span"
                    ></span>
                  </div>
                </td>
                <td class="mx-auto text-center">
                  <div class="d-flex justify-content-center align-items-center">
                    <strong>{{ item.monto }}</strong>
                  </div>
                </td>
                <td class="mx-auto text-center">
                  <div
                    class="d-flex justify-content-center align-items-center ms-4"
                    [ngClass]="getTransactionClass(item.tipo_transaccion)"
                  >
                    <i
                      [ngClass]="getTransactionIconClass(item.tipo_transaccion)"
                      class="me-2"
                    ></i>
                    {{ transactionTypes[item.tipo_transaccion].label }}
                  </div>
                </td>
                <td class="mx-auto text-center">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="d-flex flex-column align-items-start ms-4">
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Fecha de creación de solicitud"
                        tooltipClass="custom-tooltip"
                      >
                        <i
                          class="fas fa-calendar-week informative-icon fa-sm me-2"
                        ></i>
                        <span>{{ item.creado | date : "dd/MM/yyyy" }}</span>
                      </div>
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Hora de creación de solicitud"
                        tooltipClass="custom-tooltip"
                      >
                        <i class="fas fa-clock fa-sm me-2 informative-icon"></i>
                        <span>{{ item.creado | date : "HH:mm:ss" }}</span>
                      </div>
                    </div>
                  </div>
                </td>
                @if (!isMobile) {
                <td class="mx-auto text-center">
                  <div class="d-flex">
                    <div class="d-flex flex-column ms-4">
                      @if(item.id_jugador !== 0 && item.id_jugador !== null){
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Jugador"
                        tooltipClass="custom-tooltip"
                      >
                        <i class="fas fa-futbol fa-sm me-2 sorti-2"></i>
                        <span>{{ item.player }}</span>
                      </div>
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Agente"
                        tooltipClass="custom-tooltip"
                      >
                        <i class="fas fa-user-tie fa-sm me-2 sorti-2"></i>
                        <span>{{ item.agent }}</span>
                      </div>
                      }@else if(item.agent !== 0 && item.agent !== null &&
                      item.id_agent !== 0){
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Agente"
                        tooltipClass="custom-tooltip"
                      >
                        <i class="fas fa-user-tie fa-sm me-2 sorti-2"></i>
                        <span>{{ item.agent }}</span>
                      </div>
                      }@else if (item.accounting_account !== 0 &&
                      item.accounting_account !== null && item.id_codigos !==
                      0){
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Cuenta Contable"
                        tooltipClass="custom-tooltip"
                      >
                        <i class="fas fa-suitcase fa-sm me-2 sorti-2"></i>
                        <span>{{
                          item.accounting_account.name ||
                            item.accounting_account.nombre_cuenta
                        }}</span>
                      </div>
                      }
                    </div>
                  </div>
                </td>
                <td class="mx-auto text-center">
                  @if ((item.comprobante && item.comprobante !== 'null') ||
                  (item.comprobante_empresa && item.comprobante_empresa !==
                  'null')) {
                  <div class="d-flex flex-column ms-4">
                    @if (item.comprobante && item.comprobante !== 'null') {
                    <div
                      class="d-flex align-items-center me-4 mb-2"
                      ngbTooltip="Comprobante Cliente"
                      tooltipClass="custom-tooltip"
                    >
                      <i class="fas fa-futbol fa-sm me-2 client"></i>
                      <span>{{ item.comprobante }}</span>
                    </div>
                    } @if (item.comprobante_empresa && item.comprobante_empresa
                    !== 'null') {
                    <div
                      class="d-flex align-items-center me-4 mb-2"
                      ngbTooltip="Comprobante Empresa"
                      tooltipClass="custom-tooltip"
                    >
                      <i class="fas fa-user-tie fa-sm me-2 sorti"></i>
                      <span>{{ item.comprobante_empresa }}</span>
                    </div>
                    }
                  </div>
                  } @else {
                  <span>S/C</span>
                  }
                </td>

                }
                <td class="mx-auto text-start">
                  <div class="d-flex flex-column ms-4">
                    @if([TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT].includes(item.tipo_transaccion)){
                    <div class="align-items-start">
                      <span
                        >Los tipos de transacción de tipo
                        <strong>Crédito Depósito</strong> no tienen datos
                        bancarios</span
                      >
                    </div>
                    }@if([TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL].includes(item.tipo_transaccion)){
                    <div class="align-items-start">
                      <span
                        >Los tipos de transacción de tipo
                        <strong>Crédito Retiro</strong> no tienen datos
                        bancarios</span
                      >
                    </div>
                    }@else { @if (item.identificacion && item.identificacion !=
                    'null' && item.identificacion != 'undefined') {
                    <div class="d-flex align-items-center me-4 mb-2">
                      <i class="fas fa-id-card fa-sm me-2 sorti-2"></i>
                      <span>{{ item.identificacion }}</span>
                    </div>
                    } @if (item.numero_cuenta && item.numero_cuenta != 'null' &&
                    item.numero_cuenta != 'undefined') {
                    <div class="d-flex align-items-center me-4 mb-2">
                      <i class="fa-solid fa-credit-card fa-sm me-2 sorti-2"></i>
                      <span>{{ item.numero_cuenta }}</span>
                    </div>
                    } @if (item.nombre_titular && item.nombre_titular != 'null'
                    && item.nombre_titular != 'undefined' && item.nombre_titular
                    != 'SD') {
                    <div class="d-flex align-items-center me-4 mb-2">
                      <i class="fas fa-user fa-sm me-2 sorti-2"></i>
                      <span>{{ item.formatted_name }}</span>
                    </div>
                    } @if (item.id_banco && item.id_banco != 'null'&&
                    item.id_banco != 'undefined') {
                    <div class="d-flex align-items-center me-4">
                      <i class="fas fa-building-columns fa-sm me-2 sorti-2"></i>
                      <span>{{ item.bank }}</span>
                    </div>
                    } }
                  </div>
                </td>
                <td class="mx-auto text-start">
                  <div class="d-flex flex-column ms-4">
                    @if (item.id_banco_empresa) {
                    <div class="d-flex align-items-center me-4">
                      <i class="fas fa-building-columns fa-sm me-2 sorti-2"></i>
                      <span>{{ item.bank_enterprise }}</span>
                    </div>
                    }@else {
                    <span>Sin Datos Bancarios</span>
                    }@if(item.holder){
                    <div class="d-flex align-items-center me-4 mb-2 mt-1">
                      <i
                        class="fas fa-id-badge fa-sm me-2 sorti-2"
                        style="padding-left: 3px"
                      ></i>
                      <span>{{ item.formatted_holder_name }}</span>
                    </div>
                    }
                  </div>
                </td>
                @if (!isMobile) {
                <td class="mx-auto text-center">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="d-flex flex-column align-items-start ms-4">
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Fecha de actualización de solicitud"
                        tooltipClass="custom-tooltip"
                      >
                        <i
                          class="fas fa-calendar-week fa-sm me-2 informative-icon"
                        ></i>
                        <span>{{
                          item.actualizado | date : "dd/MM/yyyy"
                        }}</span>
                      </div>
                      <div
                        class="d-flex align-items-center me-4 mb-2"
                        ngbTooltip="Hora de actualización de solicitud"
                        tooltipClass="custom-tooltip"
                      >
                        <i class="fas fa-clock fa-sm me-2 informative-icon"></i>
                        <span>{{ item.actualizado | date : "HH:mm:ss" }}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="mx-auto text-center">
                  <div class="d-flex justify-content-center align-items-center">
                    {{ item.created_by }}
                  </div>
                </td>
                }
              </tr>
            </tbody>
            } }
            }
          </table>
          @if(isLoading){
          <div
            class="d-flex justify-content-between align-items-center mb-3 me-3 ms-3"
          >
            <p class="card-text placeholder-glow text-end">
              <span class="placeholder col-7 mb-2"></span>
            </p>
            <p class="card-text placeholder-glow text-end">
              <span class="placeholder col-7 mb-2"></span>
            </p>
          </div>
          } @else {
          <div
            *hasPermission="REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_TOTALS"
            class="d-flex justify-content-between align-items-center mb-3 me-3 ms-3"
          >
            <div class="total-monto-container mt-3">
              Total en Dólares: <strong>{{ totalDolares }}</strong>
            </div>
            <div class="total-monto-container text-end mt-3">
              Total en Soles: <strong>{{ totalSoles }}</strong>
            </div>
          </div>
          }
        </div>
      </div>
      }@else {
      <div class="card-body mt-2">
        @if (isLoading) {
        <div class="loader-box">
          <div class="loader-16"></div>
        </div>
        }@else {@for (item of cwData; track $index ) {
        @if (canViewRowByState(item.estado)) {
        <div class="card mb-3">
          <div class="card-body">
            <div
              class="card-more-button-holder"
              (click)="toggleMenu($index, item)"
            >
              <i class="fa-solid fa-ellipsis"></i>
            </div>
            <div class="card-c-holder">
              @for (column of columnsTable; track $index) { @if (column.value) {
              <div class="geneKeyValue card-list-col">
                <p
                  role="heading"
                  aria-level="1"
                  class="geneKeyValue__label ellipsis-text"
                >
                  {{ column.name }}
                </p>
                <br />
                @switch (column.value) { @case ('estado') {

                <div class="geneKeyValue__value ellipsis-text">
                  <i
                    *ngIf="item.estado_tiempo_espera"
                    class="fas fa-business-time fa-sm status-icon-time-out"
                    ngbTooltip="La boleta demorará 20 min"
                    tooltipClass="custom-tooltip"
                  >
                  </i>

                  <span
                    *ngIf="
                      (item.estado_revisar_boleta === 1 &&
                        (item.jugador_white_list?.lista_negra === 1 ||
                          item.agente_white_list?.lista_negra === 1)) ||
                      item.jugador_white_list?.lista_negra === 1 ||
                      item.agente_white_list?.lista_negra === 1
                    "
                    ngbTooltip="Usuario en Lista Negra"
                    tooltipClass="custom-tooltip"
                    class="status-dot status-dot-black-list"
                    [ngClass]="{
                      'status-dot-active':
                        item.jugador_white_list?.lista_negra === 1 ||
                        item.agente_white_list?.lista_negra === 1
                    }"
                  >
                  </span>

                  <span
                    *ngIf="item.estado_revisar_boleta === 1"
                    ngbTooltip="Revisar Boleta"
                    tooltipClass="custom-tooltip"
                    class="status-dot status-dot-check-ticket"
                    [ngClass]="{
                      'status-dot-active': item.estado_revisar_boleta === 1
                    }"
                  >
                  </span>
                </div>
                <p class="geneKeyValue__value ellipsis-text">
                  <span
                    [ngClass]="getStateClasses(item.estado).classes"
                    [innerHTML]="getStateClasses(item.estado).text"
                  ></span>
                </p>
                }@case ('tipo_transaccion') {
                <p
                  class="geneKeyValue__value ellipsis-text"
                  [ngClass]="getTransactionClass(item.tipo_transaccion)"
                >
                  <i
                    [ngClass]="getTransactionIconClass(item.tipo_transaccion)"
                    class="me-2"
                  ></i>
                  {{ transactionTypes[item.tipo_transaccion].label }}
                </p>
                }@case ('creado') {
                <p class="geneKeyValue__value ellipsis-text">
                  {{ item.creado | date : "dd/MM/yyyy" }}
                </p>
                <p class="geneKeyValue__value ellipsis-text">
                  {{ item.creado | date : "HH:mm:ss" }}
                </p>
                } @default {
                <p class="geneKeyValue__value ellipsis-text">
                  {{ item[column.value] }}
                </p>
                } }
              </div>
              } }
            </div>
          </div>
        </div>
        } }}
      </div>
      }
      @if (cwData && cwData.length > 0) {
      <div class="card-footer">
        <div class="row mt-3 mb-3">
          <shared-custom-pagination
            [collectionSize]="collectionSize"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onLimitChange($event)"
          ></shared-custom-pagination>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<div
  class="overlay"
  *ngIf="showMenu || showSubMenu"
  (click)="closeMenu()"
></div>
<div class="popover1" *ngIf="showMenu">
  <ul>
    <li
      (click)="openSubMenu('client')"
      style="border-top: 1px solid var(--chart-border)"
    >
      <i class="fas fa-user informative-icon me-2"></i> Ver Detalle Cliente
    </li>
    <li
      (click)="openSubMenu('enterprise')"
      style="border-top: 1px solid var(--chart-border)"
    >
      <i class="fas fa-building informative-icon me-2"></i> Ver Detalle Empresa
    </li>
    <li
      *ngFor="let button of buttons"
      (click)="onActionClick(actualRow, button)"
      [class.bot-busy-option]="isBotLocked(actualRow)"
      style="border-top: 1px solid var(--chart-border)"
    >
      <i class="fas informative-icon me-2" [ngClass]="button.icon"></i>
      {{ button.tooltip }}
    </li>
    <li (click)="closeMenu()" style="border-top: 1px solid var(--chart-border)">
      <i class="fas fa-times informative-icon me-2"></i> Close
    </li>
  </ul>
</div>
<div class="popover1" *ngIf="showSubMenu">
  <div class="submenu">
    <ul>
      <li (click)="closeSubMenu()">
        <i class="fas fa-reply informative-icon me-2"></i> Regresar
      </li>
    </ul>
    <div class="submenu-content">
      @for (column of actualItem; track $index) {
      <div class="row" style="max-width: 98%">
        <div class="col-6 ellipsis-text" style="font-weight: bold">
          <p>{{ column.key }}:</p>
        </div>
        <div class="col-6 ellipsis-text">
          {{ column.value }}
        </div>
      </div>
      }
    </div>
  </div>
</div>
